import React, { useEffect, useState } from "react";
import CommonHeaderComp from "../utils/CommonHeaderComp";
import Aos from "aos";
import "aos/dist/aos.css";
import sotryImg1 from "../assets/StoryPage/storyImg1.png";
import sotryImg2 from "../assets/StoryPage/storyImg2.png";
import img1Toppings from "../assets/StoryPage/img1Toppings.png";
import img2Toppings from "../assets/StoryPage/Img2Toppings.png";
import Footer from "./Footer";
import "../styles/privacyPolicyStyle.css";
import Loader from "../utils/Loader";
import axios from "axios";
import config from "../config";
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
  const [isLaoding, setIsLoading] = useState(false);
  const [data, setData] = useState("");
  const [policy_data, setPolicyData] = useState("");

  Aos.init({
    offset: 0,
    duration: 1000,
    once: true,
    easing: "ease-out-cubic",
    disable: "phone",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setIsLoading(true);
    const formData = new FormData()
    formData.append("page", "privacy policy")
    try {
      const res = await axios({
        method: "post",
        url: `${config.apiUrl}/single_blog`,
        data:formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        setData(res.data.data)
        setPolicyData(res.data.data.post_content);
        // console.log("pp",res.data.data.post_content);
        setIsLoading(false);
      });
    } catch (error) {
    
      console.log("Error", error);
      setIsLoading(false);
    }
  };

  return (
    <>
    <Helmet>
        <title>Privacy Policy - Rollz Ice Cream</title>
        <meta property="og:title" content="Privacy Policy - Rollz Ice Cream" />
        <meta
          property="og:description"
          content="Privacy Policy For Rollz Icecream Rollz Icecream informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data. We use your data to provide and improve the Service. By using the Service, you agree to the collection and [&hellip;]"
        />
      </Helmet>
      {isLaoding && <Loader />}
    <div className="privacy_policy_page">

      <CommonHeaderComp
        Heading="Privacy Policy"
        height="60vh"
        pageName="Privacy Policy"
        color="#ffdbe2"
      />

      {/* Image 1  */}
      <div className="storyImg1 position-absolute" data-aos="fade-left">
        <img
          src={sotryImg1}
          className="img-fluid img1"
          alt="our story img 1"
          loading="lazy"
        ></img>
        <img
          src={img1Toppings}
          className="img-fluid img1Toping"
          alt="img1 Toppings"
          loading="lazy"
        ></img>
      </div>

      {/* Image 2  */}
      <div className="storyImg2 position-absolute" data-aos="fade-rigth">
        <img
          src={sotryImg2}
          className="img-fluid img2"
          alt="our story img 2"
          loading="lazy"
        ></img>
        <img
          src={img2Toppings}
          className="img-fluid img2Toping"
          alt="img2 Toppings"
          loading="lazy"
        ></img>
      </div>

      <section className="privacy_policy_section">
        <div className="container privacy_policy_container">
          <div className="privacy_policy_heading col-12 mb-4 text-center">
            <h2>Privacy Policy</h2>
          </div>
          {/* <div className="privacy_policy_content col-12">
            <p className="mb-4">
              Rollz Icecream informs you of our policies regarding the
              collection, use, and disclosure of personal data when you use our
              Service and the choices you have associated with that data. We use
              your data to provide and improve the Service. By using the
              Service, you agree to the collection and use of information in
              accordance with this policy.
            </p>

            <div className="privacy_policy_list col-12 mb-4">
              <h4 className="mb-3"> Information Collection and Use</h4>
              <p>
                We collect several different types of information for various
                purposes to provide and improve our Service to you. Types of
                Data Collected
              </p>
              <dl>
                <dt>Personal Data</dt>
                <dd>
                  While using our Service, we may ask you to provide us with
                  certain personally identifiable information that can be used
                  to contact you. Personally identifiable information may
                  include, but is not limited to:
                </dd>
                <dd>
                  <ul>
                    <li>Email address</li>
                    <li>First name and last name</li>
                    <li>Phone number</li>
                    <li>Address, City, State, ZIP/Postal code</li>
                    <li>Cookies and Usage Data</li>
                  </ul>
                </dd>
              </dl>
            </div>

            <div className="privacy_policy_list col-12 mb-4">
              <h4 className="mb-3">Use of Data</h4>
              <p>
                Rollz Icecream uses the collected data for various purposes:
              </p>

              <ul>
                <li>To provide and maintain the Service</li>
                <li>To notify you about changes to our Service</li>
                <li>
                  To allow you to participate in interactive features of our
                  Service when you choose to do so
                </li>
                <li>To provide customer care and support</li>
                <li>
                  To provide analysis or valuable information so that we can
                  improve the Service
                </li>
                <li>To monitor the usage of the Service</li>
                <li>To detect, prevent, and address technical issues</li>
              </ul>
            </div>

            <div className="privacy_policy_list col-12 mb-4">
              <h4 className="mb-3"> Disclosure of Data</h4>
              <p>
                Rollz Icecream may disclose your Personal Data in the good faith
                belief that such action is necessary to:
              </p>

              <ul>
                <li>To comply with a legal obligation</li>
                <li>
                  To protect and defend the rights or property of Rollz Icecream
                </li>
                <li>
                  To prevent or investigate possible wrongdoing in connection
                  with the Service
                </li>
                <li>
                  To protect the personal safety of users of the Service or the
                  public
                </li>
                <li>
                  To protect the personal safety of users of the Service or the
                  public
                </li>
              </ul>
            </div>

            <div className="privacy_policy_list col-12 mb-4">
              <h4 className="mb-3"> Security of Data</h4>
              <p>
                The security of your data is important to us, but remember that
                no method of transmission over the Internet or method of
                electronic storage is 100% secure. While we strive to use
                commercially acceptable means to protect your Personal Data, we
                cannot guarantee its absolute security.
              </p>
            </div>

            <div className="privacy_policy_list col-12 mb-4">
              <h4 className="mb-3"> Service Providers</h4>
              <p>
                We may employ third party companies and individuals to
                facilitate our Service, provide the Service on our behalf,
                perform Service-related services, or assist us in analyzing how
                our Service is used. These third parties have access to your
                Personal Data only to perform these tasks on our behalf and are
                obligated not to disclose or use it for any other purpose.
              </p>
            </div>

            <div className="privacy_policy_list col-12 mb-4">
              <h4 className="mb-3"> Changes to This Privacy Policy</h4>
              <p>
                We may update our Privacy Policy from time to time. We will
                notify you of any changes by posting the new Privacy Policy on
                this page. You are advised to review this Privacy Policy
                periodically for any changes. Changes to this Privacy Policy are
                effective when they are posted on this page.
              </p>
            </div>
          </div> */}

          <div className="privacy_policy_content col-12">
            <p>
              <div 
              className="policy_content"
                dangerouslySetInnerHTML={{
                  __html:policy_data,
                }}
              />
            </p>
          </div>
        </div>
      </section>

      {/* <Footer /> */}
    </div>
    </>
  );
};

export default PrivacyPolicy;
